var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createComponentOverrides } from '../../theme/create-component-overrides';
export var createMuiCardHeaderOverrides = createComponentOverrides(function (_a) {
    var typography = _a.typography, spacing = _a.spacing, tokens = _a.tokens;
    return ({
        styleOverrides: {
            root: {
                marginBottom: spacing(3),
                padding: 0,
                '&:last-child': {
                    marginBottom: 0,
                },
            },
            content: {
                minWidth: spacing(0),
            },
            avatar: {
                alignSelf: 'flex-start',
                paddingTop: spacing(0.5),
            },
            title: {
                marginBottom: spacing(0.5),
                '&:last-child': {
                    marginBottom: 0,
                },
            },
            action: {
                marginRight: 0,
                marginTop: 0,
                marginLeft: spacing(1),
                alignSelf: 'center',
            },
            subheader: __assign(__assign({}, typography.body2), { color: tokens.color_fg_default }),
        },
    });
});
